import i18n from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { configs } from '../configs';

export const getCDNLanguageUrl = (merchantName = configs.merchantName) => {
  if (configs.cdn.hasInternalAssets) {
    return `${configs.publicUrl}/merchants/${merchantName}/locales/{{lng}}/{{ns}}.json`;
  }
  return `${configs.cdn.path}/providers/${configs.env}/dashboard/${merchantName}/locales/{{lng}}/{{ns}}.json`;
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(I18NextHttpBackend)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    react: {
      useSuspense: false //   <---- this will do the magic
    },
    fallbackLng: 'en',
    debug: configs.isDevelopment || configs.isLocal,
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      loadPath: getCDNLanguageUrl()
    }
  });

export { i18n };
